import { MdArrowDropDown } from 'react-icons/md';

import { Button } from '@/components/Button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { candidateMailReplaceTokens } from '../constants';

type VariableInsertMenuProps = {
  onInsert: (token: string) => void;
  disabled?: boolean;
};

export const mailMenuContentClassName =
  'rounded-sm! border-none! p-0! shadow-layer3! focus:outline-hidden data-[state=closed]:duration-75 data-[state=closed]:ease-in data-[state=open]:duration-100 data-[state=open]:ease-out';

export const mailMenuItemClassName =
  'block! h-10 w-full truncate rounded-none! px-sm! py-xs! text-left text-body-sm! text-main';

export default function VariableInsertMenu({ onInsert, disabled }: VariableInsertMenuProps) {
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          color="secondary"
          size="md"
          disabled={disabled}
          className="data-[state=open]:bg-gray_darken [&[data-state=open]>svg]:rotate-180"
        >
          変数の挿入
          <MdArrowDropDown className="size-5 transition-transform" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        side="top"
        align="start"
        sideOffset={4}
        className={`w-[160px] ${mailMenuContentClassName}`}
      >
        {candidateMailReplaceTokens.map((token) => (
          <DropdownMenuItem
            key={token.key}
            onClick={() => onInsert(token.token)}
            className={mailMenuItemClassName}
          >
            {token.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
